import { Label } from "../../../../models";

export const processLabelsResponse = (labels: Label[]): Label[] => {
    return labels.map((label: Label) => {
        const newLabel: Label = {
            color: label.color,
            labelUid: label.labelUid,
            name: label.name,
        }

        return newLabel;
    })
}